import { useState, useRef, useCallback, useEffect } from 'react';
import styles from './ComparadorImagenes.module.css';

const ComparadorImagenes = ({
  imagenAntes,
  imagenDespues,
  altAntes = 'Antes',
  altDespues = 'Después',
  posicionInicial = 50,
}) => {
  const [posicion, setPosicion] = useState(posicionInicial);
  const [arrastrando, setArrastrando] = useState(false);
  const contenedorRef = useRef(null);

  const calcularPosicion = useCallback((clientX) => {
    if (!contenedorRef.current) return;
    const rect = contenedorRef.current.getBoundingClientRect();
    const nueva = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
    setPosicion(nueva);
  }, []);

  const handleMouseDown = useCallback((e) => {
    e.preventDefault();
    setArrastrando(true);
  }, []);

  const handleMouseMove = useCallback((e) => {
    if (!arrastrando) return;
    calcularPosicion(e.clientX);
  }, [arrastrando, calcularPosicion]);

  const handleMouseUp = useCallback(() => setArrastrando(false), []);

  const handleTouchStart = useCallback((e) => {
    e.preventDefault();
    setArrastrando(true);
  }, []);

  const handleTouchMove = useCallback((e) => {
    if (!arrastrando) return;
    calcularPosicion(e.touches[0].clientX);
  }, [arrastrando, calcularPosicion]);

  const handleTouchEnd = useCallback(() => setArrastrando(false), []);

  useEffect(() => {
    window.addEventListener('mouseup', handleMouseUp);
    window.addEventListener('mousemove', handleMouseMove);
    return () => {
      window.removeEventListener('mouseup', handleMouseUp);
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [handleMouseUp, handleMouseMove]);

  return (
    <div
      ref={contenedorRef}
      className={styles.contenedor}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      {/* Imagen derecha (Sucio) — capa base */}
      <img
        src={imagenDespues}
        alt={altDespues}
        className={styles.imagenBase}
        draggable="false"
      />

      {/* Imagen izquierda (Limpio) — capa recortada */}
      <div
        className={styles.capaAntes}
        style={{ clipPath: `inset(0 ${100 - posicion}% 0 0)` }}
      >
        <img
          src={imagenAntes}
          alt={altAntes}
          className={styles.imagenBase}
          draggable="false"
        />
      </div>

      {/* Línea divisoria */}
      <div
        className={styles.linea}
        style={{ left: `${posicion}%` }}
      />

      {/* Handle arrastrable */}
      <div
        className={`${styles.handle} ${arrastrando ? styles.handleActivo : ''}`}
        style={{ left: `${posicion}%` }}
        onMouseDown={handleMouseDown}
        onTouchStart={handleTouchStart}
        aria-label="Deslizar para comparar"
        role="slider"
        aria-valuenow={Math.round(posicion)}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={styles.handleIcono}
        >
          <path d="M9 18l-6-6 6-6" />
          <path d="M15 6l6 6-6 6" />
        </svg>
      </div>
    </div>
  );
};

export default ComparadorImagenes;
